module.exports = __webpack_public_path__ + "media/packs/images/flags/SR-32adba644729692d80374b02816354b8.png";